import styled from '@/styles';

export { ModalShell } from '../../styles';

export const ModalHeader = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const SnippetList = styled('ul', {
  listStyle: 'none',
  padding: 0,
  maxHeight: 280,
  overflowY: 'auto',
  margin: 0,
});

export const SnippetListItem = styled('li', {
  marginBottom: 8,
});

export const SnippetTile = styled('button', {
  textAlign: 'left',
  width: '100%',
  padding: '10px 12px',
  borderRadius: 8,
  border: '1px solid $colors$neutralLightest',
  background: '#FFFFFF',
  cursor: 'pointer',
  variants: {
    active: {
      true: {
        border: '2px solid $colors$textDefault',
        background: '$colors$neutralGhost',
      },
    },
  },
});

export const SnippetTileHeader = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const SnippetTileTitle = styled('span', {
  fontWeight: 600,
});

export const SnippetTileBadge = styled('span', {
  color: '$colors$textLighter',
  fontSize: 12,
});

export const SnippetTileBody = styled('div', {
  color: '$colors$textLight',
  fontSize: 13,
  marginTop: 4,
  whiteSpace: 'pre-wrap',
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

export const StrategyCard = styled('button', {
  textAlign: 'left',
  border: '1px solid $colors$neutralLightest',
  borderRadius: 12,
  padding: 16,
  background: 'transparent',
  cursor: 'pointer',
  variants: {
    active: {
      true: {
        border: '2px solid $colors$themeDefault',
      },
    },
  },
});
